// extracted by mini-css-extract-plugin
export default {"summary":"summary--g89L1"};